import { useEffect, useState } from 'react';
import ModalCentered from '../../ui/modal-window/ModalCentered';
import styles from '../../../pages/Mailing/MailingForm/mailingForm.module.sass';
import telStyles from './telephones.module.sass';
import { api } from '../../../services/api';
import Btn_transparent from '../../ui/btn_transparent/Btn_transparent';
import TextInput from '../../ui/input/TextInput';
import sharedStyles from '../index.module.sass';
import InfoTooltip from '../../ui/infoTooltip/infoTooltip';
import { fetchTasks } from '../../../store/task-slice/apiActions';
import { useAppDispatch } from '../../../hooks/redux';
import InfoBanner from '../../ui/infoBanner/infoBanner';
import { useTranslation } from 'react-i18next';

const Telephones = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [fileText, setFileText] = useState('');
  const [taskName, setTaskName] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [error, setError] = useState('');
  const [fileLoad, setFileLoad] = useState(false);
  const [file, setFile] = useState<File | null>(null);

  const refreshTasks = () => {
    const limit = 10;
    const offset = 0;
    dispatch(fetchTasks({ limit, offset, operation: 'parsing' }));
  };

  useEffect(() => {
    refreshTasks();
  }, []);

  const fileHandlerOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile) {
      setFileText(selectedFile.name);
      setFile(selectedFile);
      uploadFile(selectedFile);
    }
  };

  const uploadFile = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    api
      .post('/telegram/parser/phones/upload_file', formData)
      .then((response) => {
        if (response.status === 200) {
          setFileLoad(true);
        }
      })
      .catch((e) => {
        setError(e);
      });
  };

  const submitHandler = async () => {
    if (!file || !taskName) {
      setError(t('usersParsing.selectFileAndEnterTaskName'));
      return;
    }

    const fileExtension = file.name.split('.').pop(); // Получаем расширение файла

    const requestData = {
      id_bot: 0,
      task_name: taskName,
      rerun: false,
      export_file_ext: fileExtension,
      phones: [],
      phones_filename: file.name,
    };

    try {
      const response = await api.post('/telegram/parser/phones', requestData);
      if (response.status === 200) {
        setModalShow(true);
        refreshTasks();
      }
    } catch (e: any) {
      setError(e.response.data.detail || t('usersFiltration.errorSendingData'));
    }
  };

  return (
    <section className={telStyles.wrapper}>
      <ModalCentered
        show={modalShow}
        headerText={t('usersParsing.parsingStarted')}
        bodyText={t('usersFiltration.parsingResultsInHistoryTable')}
        btnText={t('usersParsing.close')}
        onHide={() => setModalShow(false)}
      />

      <div className={telStyles.textWrapper}>
        <span className={telStyles.textHeader}>
          {t('usersParsing.convertNumbers')}.
        </span>
        <span>{t('usersParsing.phoneInfo')}:</span>
        <ul className={telStyles.textList}>
          <div>
            <li>id</li>
            <li>username</li>
            <li>first_name</li>
            <li>last_name</li>
            <li>premium (true/false)</li>
            <li>bot (true/false)</li>
          </div>
          <div>
            <li>scam (true/false)</li>
            <li>deleted (true/false)</li>
            <li>verified (true/false)</li>
            <li>restricted (true/false)</li>
            <li>fake (true/false)</li>
          </div>
        </ul>
        <span>{t('usersParsing.conversionPaid')}.</span>
        <span>{t('usersParsing.conversionCost')}:</span>
        <ul className={telStyles.textList}>
          <div>
            <li>{t('usersParsing.conversionPrice_100_1000')}</li>
            <li>{t('usersParsing.conversionPrice_1000_10000')}</li>
            <li>{t('usersParsing.conversionPrice_10000_50000')}</li>
            <li>{t('usersParsing.conversionPrice_50000_100000')}</li>
            <li>{t('usersParsing.conversionPrice_100000+')}</li>
          </div>
        </ul>
      </div>
      <div className={styles.uploadedFileInput}>
        <br />
        <input
          type="file"
          id="uploaded-file"
          onChange={fileHandlerOnChange}
          className={telStyles.input}
        />
        <label htmlFor="uploaded-file">
          <p>{fileText ? fileText : t('usersTarget.chooseFile')}</p>
        </label>
        {fileLoad ? (
          <span className={telStyles.text}>
            {t('usersParsing.fileUploaded')}
          </span>
        ) : null}
      </div>
      <div className={sharedStyles.fieldWrapper}>
        <h3 className={sharedStyles.header}>{t('common.taskName')}</h3>
        <InfoTooltip text={t('usersParsing.parsingNameHint')} />
        <TextInput
          style={{ maxWidth: '610px' }}
          name="name"
          type="text"
          placeholder={t('usersParsing.taskName')}
          hintMessage={t('usersParsing.titleVisibleOnlyToYou')}
          value={taskName}
          onChange={(e) => setTaskName(e.target.value)}
        />
      </div>
      {error && <p className={telStyles.error}>{error}</p>}
      <Btn_transparent
        style={{ width: '100%' }}
        variant="standart"
        type="button"
        onClick={submitHandler}
      >
        {t('usersParsing.startConversion')}
      </Btn_transparent>
    </section>
  );
};

export default Telephones;
